import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import LoadingSpinner from '../components/ui/LoadingSpinner';

const Notifications = React.lazy(() => import('../pages/Notifications'));
const NotificationDetail = React.lazy(() => import('../pages/NotificationDetail'));

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<div className="flex justify-center items-center min-h-screen"><LoadingSpinner size="lg" color="orange" /></div>}>
    {children}
  </Suspense>
);

export const notificationRoutes = (
  <>
    <Route path="/notifications" element={<SuspenseWrapper><Notifications /></SuspenseWrapper>} />
    <Route path="/notification-detail" element={<SuspenseWrapper><NotificationDetail /></SuspenseWrapper>} />
  </>
);
